(function (window, document) {
  "use strict";

  var DNB = window.DNB;

  // Ana site anasayfası — home.main.min.js. Yalnızca ana sitenin section'ları.
  // Her modül kendi kök elementini kontrol eder; CMS'ten kapatılan section
  // sessizce atlanır.
  document.addEventListener("DOMContentLoaded", function () {
    DNB.safeInit("LeftBar", function () { DNB.LeftBar.init(); });
    DNB.safeInit("HomeHero", function () { DNB.HomeHero.init(); });
    DNB.safeInit("SectionReveal", function () { DNB.SectionReveal.init(); });
    DNB.safeInit("About", function () { DNB.About.init(); });
    DNB.safeInit("VideoPopup", function () { DNB.VideoPopup.init(); });
    DNB.safeInit("Production", function () { DNB.Production.init(); });
    DNB.safeInit("References", function () { DNB.References.init(); });
    DNB.safeInit("SolutionsMobile", function () {
      var grid = document.querySelector(".solutions__grid");
      if (!grid) return;
      var cards = grid.querySelectorAll(".solutions__card");
      if (!cards.length) return;
      var mq = window.matchMedia("(max-width: 768px)");

      function sync() {
        cards.forEach(function (card, index) {
          card.classList.toggle("is-open", mq.matches && index === 0);
        });
      }

      cards.forEach(function (card) {
        var title = card.querySelector(".solutions__card-title");
        if (!title) return;
        title.addEventListener("click", function () {
          if (!mq.matches) return;
          var willOpen = !card.classList.contains("is-open");
          cards.forEach(function (item) { item.classList.remove("is-open"); });
          if (willOpen) card.classList.add("is-open");
        });
      });

      sync();
      if (mq.addEventListener) mq.addEventListener("change", sync);
      else if (mq.addListener) mq.addListener(sync);
    });
  });
})(window, document);
